import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const CTX = createContext(null);
const KEY = 'community_token';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function UserAuthProvider({ children }) {
  const [user, setUser]     = useState(null);   // null = loading, false = not logged in, obj = logged in
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(KEY);
    if (!token) { setLoading(false); setUser(false); return; }
    axios.get(`${API}/user/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setUser(r.data))
      .catch(() => { localStorage.removeItem(KEY); setUser(false); })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback((token, userData) => {
    localStorage.setItem(KEY, token);
    setUser(userData);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(KEY);
    setUser(false);
  }, []);

  const authHeaders = useCallback(() => {
    const token = localStorage.getItem(KEY);
    return token ? { Authorization: `Bearer ${token}` } : {};
  }, []);

  return (
    <CTX.Provider value={{ user, loading, login, logout, authHeaders, API }}>
      {children}
    </CTX.Provider>
  );
}

export function useUserAuth() {
  return useContext(CTX);
}
